var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.61523 7.76921L8.64408 13.6923L18.6922 1.84613","stroke":"white","strokeWidth":"3.38462","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Check.defaultProps = {"width":"21","height":"16","viewBox":"0 0 21 16","fill":"none"};

module.exports = Check;

Check.default = Check;
